import type { TGetListaDeImobiliariasCorretoresParams } from '@/features/proposta/interfaces/imobiliarias.types'

export const propostaKeys = {
  proposta: ['proposta'] as const,
  numero: (numero: number) => [...propostaKeys.proposta, numero] as const,
  revisar: (numero: number) => [...propostaKeys.proposta, 'revisar', numero] as const,
  duplicar: (numero: number) => [...propostaKeys.proposta, 'duplicar', numero] as const,
  pessoaJuridica: (cnpj: string) => [...propostaKeys.proposta, 'pessoa-juridica', cnpj] as const,
  listaVendedores: () => [...propostaKeys.proposta, 'vendedores'] as const,
  listaImobiliariasCorretores: (descricao: TGetListaDeImobiliariasCorretoresParams) =>
    [...propostaKeys.proposta, 'imobiliarias-corretores', descricao] as const,
  listaCorretagens: (simulacoesIds: string[]) => [...propostaKeys.proposta, 'corretagens', ...simulacoesIds] as const,
  listaCompradoresDocumentos: (numero: number) => [...propostaKeys.proposta, 'compradores-documentos', numero] as const,
  envioDocumentos: () => [...propostaKeys.proposta, 'envio-documentos'] as const,
  documentos: () => [...propostaKeys.proposta, 'documentos'],
  documentosPessoa: (pessoaId: string, numeroProposta: string) => [
    ...propostaKeys.proposta,
    'documentos',
    pessoaId,
    numeroProposta,
  ],
}
